// "Key facts" answer block — short, quotable statements for AI assistants and featured snippets (speakable).
// Placeholders: {rooms} {min} {max} {checkin} {checkout} {phone}
export const keyFacts = {
  en: {
    title: 'Key facts',
    summary: 'Hotel La Rosa Negra is a simple, family-run 3-star hotel about 2 minutes on foot from the sand of Velika Plaža (Long Beach) in Ulcinj, Montenegro. Every room rate includes half board (breakfast and dinner), the outdoor pool, WiFi and parking.',
    facts: [
      ['Location', 'About 2 minutes on foot to the sand of Velika Plaža – 12 km of beach, 5 km from Ulcinj Old Town'],
      ['Included in the price', 'Breakfast + dinner (half board), outdoor pool, free WiFi, free parking'],
      ['Rooms', '{rooms} room types with sea-view balconies · €{min}–{max} per night'],
      ['Check-in / check-out', '{checkin} / {checkout} · 24-hour reception'],
      ['Airports', 'Podgorica (TGD) and Tivat (TIV) about 90 min · private transfer €80 one way'],
      ['Best for', 'Families with children, couples, kite-surfers · season May–October'],
      ['Book direct', '10% below our Booking.com price, no booking fees · {phone} (WhatsApp)'],
    ],
  },
  me: {
    title: 'Osnovne informacije',
    summary: 'Hotel La Rosa Negra je jednostavan porodični hotel sa 3 zvjezdice oko 2 minuta hoda od pijeska Velike plaže u Ulcinju, Crna Gora. Svaka cijena sobe uključuje polupansion (doručak i večeru), otvoreni bazen, WiFi i parking.',
    facts: [
      ['Lokacija', 'Oko 2 minuta pješke do pijeska Velike plaže – 12 km plaže, 5 km od Starog grada Ulcinja'],
      ['Uključeno u cijenu', 'Doručak + večera (polupansion), otvoreni bazen, besplatan WiFi, besplatan parking'],
      ['Sobe', '{rooms} tipova soba sa balkonima i pogledom na more · €{min}–{max} po noći'],
      ['Prijava / odjava', '{checkin} / {checkout} · recepcija 24 h'],
      ['Aerodromi', 'Podgorica (TGD) i Tivat (TIV) oko 90 min · privatni transfer €80 u jednom smjeru'],
      ['Idealno za', 'Porodice sa djecom, parove, kajt-surfere · sezona maj–oktobar'],
      ['Rezervišite direktno', '10% ispod naše cijene na Booking.com, bez provizije · {phone} (WhatsApp)'],
    ],
  },
  sq: {
    title: 'Fakte kryesore',
    summary: 'Hotel La Rosa Negra është një hotel i thjeshtë familjar 3-yjor rreth 2 minuta në këmbë nga rëra e Plazhit të Madh (Velika Plaža) në Ulqin, Mal i Zi. Çdo çmim dhome përfshin gjysmëpension (mëngjes dhe darkë), pishinën e hapur, WiFi dhe parkim.',
    facts: [
      ['Vendndodhja', 'Rreth 2 minuta në këmbë deri te rëra e Plazhit të Madh – 12 km plazh, 5 km nga Kalaja e Ulqinit'],
      ['Të përfshira në çmim', 'Mëngjes + darkë (gjysmëpension), pishinë e hapur, WiFi falas, parkim falas'],
      ['Dhomat', '{rooms} lloje dhomash me ballkon me pamje nga deti · €{min}–{max} për natë'],
      ['Check-in / check-out', '{checkin} / {checkout} · recepsion 24 orë'],
      ['Aeroportet', 'Podgorica (TGD) dhe Tivat (TIV) rreth 90 min · transfer privat €80 një drejtim'],
      ['Ideal për', 'Familje me fëmijë, çifte, kite-surfistë · sezoni maj–tetor'],
      ['Rezervoni direkt', '10% nën çmimin tonë në Booking.com, pa komision · {phone} (WhatsApp)'],
    ],
  },
  de: {
    title: 'Wichtige Fakten',
    summary: 'Das Hotel La Rosa Negra ist ein einfaches, familiengeführtes 3-Sterne-Hotel etwa 2 Gehminuten vom Sand des Velika Plaža (Langer Strand) in Ulcinj, Montenegro. Jeder Zimmerpreis beinhaltet Halbpension (Frühstück und Abendessen), den Außenpool, WLAN und Parkplatz.',
    facts: [
      ['Lage', 'Etwa 2 Gehminuten zum Sand des Velika Plaža – 12 km Strand, 5 km zur Altstadt von Ulcinj'],
      ['Im Preis enthalten', 'Frühstück + Abendessen (Halbpension), Außenpool, kostenloses WLAN, kostenloser Parkplatz'],
      ['Zimmer', '{rooms} Zimmertypen mit Meerblick-Balkon · €{min}–{max} pro Nacht'],
      ['Check-in / Check-out', '{checkin} / {checkout} · Rezeption rund um die Uhr'],
      ['Flughäfen', 'Podgorica (TGD) und Tivat (TIV) ca. 90 Min. · Privattransfer €80 pro Strecke'],
      ['Ideal für', 'Familien mit Kindern, Paare, Kitesurfer · Saison Mai–Oktober'],
      ['Direkt buchen', '10 % unter unserem Booking.com-Preis, keine Buchungsgebühren · {phone} (WhatsApp)'],
    ],
  },
  ru: {
    title: 'Ключевые факты',
    summary: 'Hotel La Rosa Negra — простой семейный отель 3* примерно в 2 минутах ходьбы от песка пляжа Велика Плажа (Длинный пляж) в Улцине, Черногория. В стоимость каждого номера включён полупансион (завтрак и ужин), открытый бассейн, Wi-Fi и парковка.',
    facts: [
      ['Расположение', 'Около 2 минут пешком до песка Велика Плажа – 12 км пляжа, 5 км до Старого города Улциня'],
      ['Включено в стоимость', 'Завтрак + ужин (полупансион), открытый бассейн, бесплатный Wi-Fi, бесплатная парковка'],
      ['Номера', '{rooms} типов номеров с балконами с видом на море · €{min}–{max} за ночь'],
      ['Заезд / выезд', '{checkin} / {checkout} · стойка регистрации 24 часа'],
      ['Аэропорты', 'Подгорица (TGD) и Тиват (TIV) около 90 мин · частный трансфер €80 в одну сторону'],
      ['Идеально для', 'Семей с детьми, пар, кайтсёрферов · сезон май–октябрь'],
      ['Бронируйте напрямую', 'На 10% ниже нашей цены на Booking.com, без комиссий · {phone} (WhatsApp)'],
    ],
  },
  pl: {
    title: 'Najważniejsze fakty',
    summary: 'Hotel La Rosa Negra to prosty, rodzinny hotel 3* około 2 minuty pieszo od piasku plaży Velika Plaža (Długa Plaża) w Ulcinju, Czarnogóra. Każda cena pokoju obejmuje wyżywienie HB (śniadanie i obiadokolację), basen zewnętrzny, WiFi i parking.',
    facts: [
      ['Lokalizacja', 'Około 2 minuty pieszo do piasku Velika Plaža – 12 km plaży, 5 km od Starego Miasta w Ulcinju'],
      ['W cenie', 'Śniadanie + obiadokolacja (HB), basen zewnętrzny, bezpłatne WiFi, bezpłatny parking'],
      ['Pokoje', '{rooms} typów pokoi z balkonem i widokiem na morze · €{min}–{max} za noc'],
      ['Zameldowanie / wymeldowanie', '{checkin} / {checkout} · recepcja całodobowa'],
      ['Lotniska', 'Podgorica (TGD) i Tivat (TIV) ok. 90 min · prywatny transfer €80 w jedną stronę'],
      ['Idealny dla', 'Rodzin z dziećmi, par, kitesurferów · sezon maj–październik'],
      ['Rezerwuj bezpośrednio', '10% poniżej naszej ceny na Booking.com, bez opłat rezerwacyjnych · {phone} (WhatsApp)'],
    ],
  },
  hu: {
    title: 'Fontos tudnivalók',
    summary: 'A Hotel La Rosa Negra egyszerű, családi vezetésű 3 csillagos hotel kb. 2 perc sétára a Velika Plaža (Hosszú strand) homokjától, Ulcinjban, Montenegróban. Minden szobaár tartalmazza a félpanziót (reggeli és vacsora), a szabadtéri medencét, a WiFi-t és a parkolást.',
    facts: [
      ['Elhelyezkedés', 'Kb. 2 perc séta a Velika Plaža homokjáig – 12 km strand, 5 km az ulcinji óvárostól'],
      ['Az árban benne', 'Reggeli + vacsora (félpanzió), szabadtéri medence, ingyenes WiFi, ingyenes parkolás'],
      ['Szobák', '{rooms} szobatípus tengerre néző balkonnal · €{min}–{max} / éjszaka'],
      ['Bejelentkezés / kijelentkezés', '{checkin} / {checkout} · recepció 0–24'],
      ['Repülőterek', 'Podgorica (TGD) és Tivat (TIV) kb. 90 perc · privát transzfer €80 / irány'],
      ['Ideális', 'Gyermekes családoknak, pároknak, kite-szörfösöknek · szezon május–október'],
      ['Foglaljon közvetlenül', '10%-kal a Booking.com-os árunk alatt, foglalási díj nélkül · {phone} (WhatsApp)'],
    ],
  },
};

export const fillFact = (s, vars) => String(s).replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : m));

export const getKeyFacts = (lang, vars) => {
  const k = keyFacts[lang] || keyFacts.en;
  return { title: k.title, summary: fillFact(k.summary, vars), facts: k.facts.map(([l, v]) => [l, fillFact(v, vars)]) };
};

export const keyFactsVars = (hotelInfo, rooms) => {
  const prices = (rooms || []).map((r) => Number(r.price)).filter((n) => n > 0);
  return {
    rooms: (rooms || []).length || 13,
    min: prices.length ? Math.min(...prices) : 60,
    max: prices.length ? Math.max(...prices) : 235,
    checkin: (hotelInfo && hotelInfo.checkIn) || '14:00',
    checkout: (hotelInfo && hotelInfo.checkOut) || '10:00',
    phone: (hotelInfo && hotelInfo.phone) || '+382 69 533 984',
  };
};
